import { Menu, MenuItem } from "@mui/material";
import React, { ReactNode, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FeatherIcon from "feather-icons-react";

import { DropdownButton } from "./Dropdown.styled";

import { Box, Stack, Typography } from "@components/base";

interface Component<T> {
  title: string;
  items: {
    label: string | ReactNode;
    item: T;
  }[];
  onClickItem: (item: T) => void;
  multiSelect?: boolean;
  selected?: T[];
}

const Component = <T,>({
  title,
  items,
  onClickItem,
  multiSelect,
  selected,
}: Component<T>): ReactNode => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <DropdownButton
        onClick={handleOpen}
        variant="outlined"
        color="primary"
        endIcon={<FeatherIcon icon="chevron-down" size={20} />}
      >
        {title}
      </DropdownButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map((item) => (
          <MenuItem onClick={() => onClickItem(item.item)} key={item.item as string}>
            {multiSelect ? (
              <Stack direction="row" spacing={1}>
                {selected?.includes(item.item) ? (
                  <CheckBoxIcon />
                ) : (
                  <CheckBoxOutlineBlankIcon />
                )}
                <Typography>{item.label}</Typography>
              </Stack>
            ) : (
              <Typography>{item.label}</Typography>
            )}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default Component;
